/** Closing a popover, menu or card when you are done with it (2026-10-02).
 *
 *  A press anywhere outside it closes it, caught in the capture phase so a
 *  pane that stops its own clicks cannot keep it open; so does Esc; so does
 *  focus leaving the page for a frame, because a click inside a message
 *  body lands in its iframe and the page never hears the press. Returns the
 *  cleanup for a useEffect. */
export function listenForDismiss(isInside: (target: Node) => boolean, close: () => void): () => void {
  const onPress = (e: PointerEvent) => {
    if (!isInside(e.target as Node)) close();
  };
  const onKey = (e: KeyboardEvent) => {
    if (e.key === "Escape") close();
  };
  const onBlur = () => close();
  document.addEventListener("pointerdown", onPress, true);
  document.addEventListener("keydown", onKey);
  window.addEventListener("blur", onBlur);
  return () => {
    document.removeEventListener("pointerdown", onPress, true);
    document.removeEventListener("keydown", onKey);
    window.removeEventListener("blur", onBlur);
  };
}
